// The one <section> wrapper every case study variant renders through: page
// rhythm, container width and the optional heading live here, nowhere else.
export default function SectionShell(props: {
  variant: string;
  title?: string;
  className?: string;
  children?: any;
}) {
  const { variant, title, className, children } = props;

  return (
    <section className={`case-section case-section--${variant}${className ? ` ${className}` : ""}`}>
      {title ? <h2 className="case-section-title">{title}</h2> : null}
      {children}
    </section>
  );
}
